import { MembershipsCreatorV2ApiClient } from '@fourthwall/services/dist/MembershipsCreatorV2ApiClient'
import { createMutationHook } from '@fourthwall/utils'

export const useStartLiveStreamPostMutation = createMutationHook(
  MembershipsCreatorV2ApiClient.startLiveStreamPost,
  {
    mutationKey: ['startLiveStreamPost'],
  },
)
